export const objectToArray = (key: string, data: any) => {
  let tempArray: Array<object> = [];
  Object.keys(data).forEach((e: string) => {
    const item = data[e];
    const isPlainObject = item !== null && typeof item === "object";
    tempArray.push(isPlainObject ? { ...item, [key]: e } : { [key]: e });
  });
  return tempArray;
};
